export enum EEventJoiningStatus {
    JOINING = "JOINING",
    INTERESTED = "INTERESTED",
    NOT_JOINING = "NOT_JOINING"
}